import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import de from './locales/de.json'

const messages = {
  en,
  de
}

export default createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
  legacy: false
})